// pt-BR strings of the content language (decision D37.3). English source: en-content.ts.
import type { MessageKey } from "./en.ts";

export const ptBRContent: Partial<Record<MessageKey, string>> = {
  "settings.tab.general": "Geral",
  "contentLanguage.title": "Idioma do conteúdo",
  "contentLanguage.body":
    "O idioma em que os agentes escrevem o que as pessoas leem: títulos, descrições e critérios de aceite das tarefas, apontamentos de revisão, resumos e explicações. Código, identificadores, nomes de arquivo e mensagens de commit nunca são traduzidos.",
  "contentLanguage.label": "Idioma do conteúdo",
  "contentLanguage.hint": "Vale para o texto novo. As tarefas existentes podem ser traduzidas no Kanban de cada projeto.",
  "contentLanguage.adminOnly": "Só administradores da organização podem alterar.",
  "contentLanguage.saved": "Idioma do conteúdo salvo",
  "contentLanguage.projectLabel": "Idioma do conteúdo",
  "contentLanguage.projectHint": "O idioma em que os agentes escrevem as tarefas e revisões deste projeto.",
  "contentLanguage.inherit": "O mesmo da organização",

  "translateTasks.button": "Traduzir tarefas",
  "translateTasks.running": "Traduzindo…",
  "translateTasks.confirmTitle": "Traduzir as tarefas para {language}?",
  "translateTasks.confirmBody":
    "{count} tarefa(s) ainda não iniciada(s) terão título, descrição e critérios de aceite reescritos em {language} pelo modelo do planejador. O gasto tem teto de {cap}.",
  "translateTasks.kept": "Identificadores de requisito, links, nomes de arquivo e código ficam como estão. Tarefas já iniciadas não são alteradas.",
  "translateTasks.confirm": "Traduzir",
  "translateTasks.paidTitle": "O modelo do planejador é pago",
  "translateTasks.paidBody": "Traduzir {count} tarefa(s) com {model} pode custar até {cap}. Confirme para gastar.",
  "translateTasks.confirmPaid": "Confirmar e traduzir",
  "translateTasks.done": "{translated} tarefa(s) traduzida(s), {skipped} ignorada(s)",
  "translateTasks.failed": "A tradução falhou",
};
